<template>
    <div>
        <!-- 顶部导航 -->
        <header class="header">
            <div class="header-content">
                <img src="@/assets/images/logo.svg" class="logo" alt="" />
                <h1 class="header-title">Chicchi Nails</h1>
            </div>
        </header>

        <div class="container">
            <router-link :to="`/home?id=${departmentId}`" class="back-link">← {{ $it.back_to_service_list }}</router-link>

            <h2 class="section-title" style="margin-top: 20px">{{ $it.booking_info }}</h2>

            <!-- 选中的服务列表 -->

            <el-card class="selected-services">
                <div class="section-title">{{ $it.selected_service }}</div>

                <div>
                    <div v-for="(service, index) in selectedServices" :key="service.id || index" class="service-item">
                        <div class="service-info">
                            <h4 class="service-name">
                                <!-- <span v-if="service.color" class="service-color" :style="serviceColorStyle(service.color)"></span> -->
                                {{ service.name }}
                                <!-- <span v-if="service.shortName" class="service-short-name">{{ service.shortName }}</span> -->
                            </h4>
                            <p class="service-duration">{{ service.duration }} minuto</p>
                            <p v-if="service.serviceTime" class="service-time">{{ service.serviceTime }}</p>
                        </div>
                        <div class="service-price">{{ formatPrice(service.price) }}</div>
                    </div>
                    <div class="total-info">
                        <span class="total-label">{{ $it.total }}:</span>
                        <span class="total-amount">{{ formatPrice(totalPrice) }}</span>
                    </div>
                </div>
                <div v-if="isEditMode" class="service-edit-panel">
                    <div class="edit-service-categories">
                        <button v-for="(category, key) in serviceData" :key="key" type="button" class="edit-category" :class="{ active: activeCategory === key, selected: hasCategorySelected(key) }" @click="setActiveCategory(key)">
                            <span>{{ getCategoryName(key) }}</span>
                            <span>({{ category.count }})</span>
                        </button>
                    </div>

                    <div class="edit-service-list">
                        <div v-if="serviceListLoading" class="service-empty">Caricamento...</div>
                        <div v-else-if="!filteredServices.length" class="service-empty">Nessun servizio disponibile</div>
                        <template v-else>
                            <div v-for="service in filteredServices" :key="service.serviceId" class="service-option">
                                <div class="service-info">
                                    <h4 class="service-name">{{ service.name }}</h4>
                                    <p class="service-duration">{{ service.duration }} minuto</p>
                                    <p v-if="service.description" class="service-description">{{ service.description }}</p>
                                </div>
                                <div class="service-action">
                                    <div class="service-price">{{ formatPrice(service.price) }}</div>
                                    <button type="button" class="service-toggle" :class="{ selected: service.selected }" @click="toggleServiceSelection(service)">
                                        {{ service.selected ? $it.selected : $it.unselected }}
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="total-info">
                        <span class="total-label">{{ $it.total }}:</span>
                        <span class="total-amount">{{ formatPrice(totalPrice) }}</span>
                    </div>
                </div>
            </el-card>

            <!-- 预约表单 -->
            <el-card class="booking-section">
                <!-- <div class="section-title">Informazioni sulla prenotazione</div> -->
                <el-form ref="bookingForm" :model="formData" :rules="rules" @submit.native.prevent>
                    <!-- 预约时间信息组 -->
                    <h4 class="info-group-title">{{ $it.select_booking_time }}</h4>
                    <el-form-item label="" prop="date">
                        <div @click="showDatePicker" class="custom-date-picker">
                            <span><span style="color: red">*</span> {{ $it.booking_date }}</span>
                            <span>{{ formatDisplayDate(formData.date) }} ></span>
                        </div>

                        <!-- 自定义日期选择弹窗 -->
                        <div class="date-picker-modal" v-if="datePickerVisible">
                            <div class="date-picker-content">
                                <div class="date-picker-header">
                                    <h3>Seleziona data</h3>
                                    <!-- <span class="close-btn" @click="datePickerVisible = false">&times;</span> -->
                                </div>

                                <div class="calendar-header">
                                    <button type="button" class="nav-btn" @click="changeWeek(-1)">&lt;</button>
                                    <div class="current-month">{{ currentWeekDisplay }}</div>
                                    <button type="button" class="nav-btn" @click="changeWeek(1)">&gt;</button>
                                </div>

                                <table class="calendar">
                                    <thead>
                                        <tr>
                                            <th>dom</th>
                                            <th>lun</th>
                                            <th>mar</th>
                                            <th>mer</th>
                                            <th>gio</th>
                                            <th>ven</th>
                                            <th>sab</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(week, weekIndex) in calendarDays" :key="'week-' + weekIndex">
                                            <td v-for="(day, dayIndex) in week" :key="'day-' + dayIndex">
                                                <div
                                                    v-if="day.date !== null"
                                                    class="calendar-day"
                                                    :class="{
                                                        'other-month': day.month !== currentMonth,
                                                        today: isToday(day),
                                                        selected: isSelected(day),
                                                        disabled: isDisabledDate(day)
                                                    }"
                                                    @click="!isDisabledDate(day) && selectDate(day)">
                                                    {{ day.date }}
                                                </div>
                                                <div v-else class="calendar-day empty-day"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="date-picker-footer">
                                    <button type="button" class="cancel-btn" @click="datePickerVisible = false">{{ $it.cancel }}</button>
                                    <button type="button" class="confirm-btn" @click="confirmDate">{{ $it.confirm }}</button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="" prop="time">
                        <div @click="showTimePicker" class="custom-date-picker">
                            <span><span style="color: red">*</span> {{ $it.booking_time }}</span>
                            <span>{{ formData.time }} ></span>
                        </div>

                        <!-- 自定义时间选择弹窗 -->
                        <div class="date-picker-modal" v-if="timePickerVisible">
                            <div class="date-picker-content">
                                <div class="date-picker-header">
                                    <h3>Scegli un orario</h3>
                                    <span class="close-btn" @click="timePickerVisible = false">&times;</span>
                                </div>

                                <div class="time-list">
                                    <div v-for="(time, index) in availableTimes" :key="index" class="time-item" :class="{ selected: selectedTime === time }" @click="selectTime(time)">
                                        {{ time }}
                                    </div>
                                </div>

                                <div class="date-picker-footer">
                                    <button type="button" class="cancel-btn" @click="timePickerVisible = false">{{ $it.cancel }}</button>
                                    <button type="button" class="confirm-btn" @click="confirmTime">{{ $it.confirm }}</button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 客户信息组 -->
                    <h4 class="info-group-title">{{ $it.fill_customer_info }}</h4>
                    <el-form-item :label="$it.name" prop="name">
                        <el-input v-model="formData.name" :disabled="resultViewMode" :placeholder="$it.please_input_name"></el-input>
                    </el-form-item>

                    <el-form-item :label="$it.phone" prop="phone">
                        <el-input v-model="formData.phone" maxlength="10" :disabled="resultViewMode" :placeholder="$it.please_input_phone"></el-input>
                    </el-form-item>

                    <el-form-item :label="$it.email" prop="email">
                        <el-input v-model="formData.email" :disabled="isViewMode" :placeholder="$it.please_input_email"></el-input>
                    </el-form-item>

                    <el-form-item :label="$it.remark">
                        <el-input type="textarea" v-model="formData.remark" :disabled="isViewMode" :placeholder="$it.please_input_remark" rows="3"></el-input>
                    </el-form-item>

                    <!-- 按钮组 -->
                    <el-form-item v-if="!isViewMode && !isEditMode">
                        <el-button type="danger" :loading="loading" @click="submitForm">{{ $it.confirm_your_reservation }}</el-button>
                    </el-form-item>
                </el-form>
                <!-- 修改预约 -->
                <el-button v-if="isViewMode" type="danger" @click="startEdit">{{ $it.modify_reservation }}</el-button>
                <!-- 取消编辑 -->
                <el-button v-if="isEditMode" @click="cancelEdit">{{ $it.cancel_edit }}</el-button>
                <!-- 保存修改 -->
                <el-button class="cancels2" v-if="isEditMode" :loading="loading" type="danger" @click="saveEdit">{{ $it.save_edit }}</el-button>
                <!-- 取消预约 -->

                <el-button class="cancels" v-if="isViewMode && !isEditMode" @click="cancelAppointment">{{ $it.cancel_reservation }}</el-button>
            </el-card>
        </div>

        <!-- 成功提示框 -->
        <el-dialog :title="successInfo.title" :visible.sync="successDialogVisible" width="40%" :fullscreen="isMobile" center>
            <div style="text-align: center">
                <i class="el-icon-success" style="font-size: 48px; color: #67c23a; margin-bottom: 20px"></i>
                <p class="successInfo-message">{{ successInfo.message }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="openLink">Conferma</el-button>
            </span>
        </el-dialog>
        <!-- 失败提示框 -->
        <el-dialog :title="successInfo.title" :visible.sync="successDialogVisible_err" width="40%" :fullscreen="isMobile" center>
            <div style="text-align: center">
                <i class="el-icon-success" style="font-size: 48px; color: #f56c6c; margin-bottom: 20px"></i>
                <p class="successInfo-message">{{ successInfo.message }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="successDialogVisible_err = false">Conferma</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import dayjs from 'dayjs'
import { formatDisplayDate, formatPrice } from '@/utils/formatters'
export default {
    name: 'AppointmentDetailView',
    data() {
        const initialDate = new Date()
        initialDate.setHours(0, 0, 0, 0)
        return {
            totalPrice: 0,
            selectedServices: [],
            isMobile: window.innerWidth <= 768,

            // 表单数据
            formData: {
                date: 'Seleziona data',
                time: 'Scegli un orario',
                staffName: 'Arrivo in negozio',
                name: '',
                phone: '',
                email: '',
                remark: ''
            },
            loading: false,

            // 表单验证规则
            rules: {
                name: [{ required: true, message: 'Inserisci il tuo nome', trigger: 'blur' }],
                phone: [
                    { required: true, message: 'Inserisci il tuo numero di telefono', trigger: 'blur' }
                    // { validator: validatePhone, trigger: 'blur' }
                ]
                // email: [{ validator: validateEmail, trigger: 'blur' }]
            },

            // 日期选择器配置
            datePickerOptions: {
                disabledDate(date) {
                    // 禁用今天之前的日期
                    return date < new Date(new Date().setHours(0, 0, 0, 0))
                }
            },

            // 可用时间选项
            availableTimes: [],
            //服务人员
            staffList: [],
            // 模式控制
            isViewMode: false,
            isEditMode: false,

            // 成功提示框
            successDialogVisible: false,
            successInfo: {
                title: 'Appuntamento confermato',
                message: 'Abbiamo inviato i dettagli dell’appuntamento al tuo numero di telefono e alla tua e-mail.\nTi aspettiamo!'
            },

            // 自定义日期选择器
            datePickerVisible: false,
            currentDisplayDate: initialDate, // Reference date for the current week
            currentYear: initialDate.getFullYear(),
            currentMonth: initialDate.getMonth(), // 0-indexed
            calendarDays: [], // Will hold one week: [[day1, ..., day7]]
            selectedDate: null,
            currentWeekStartDate: dayjs().startOf('week').format('YYYY-MM-DD'),
            currentWeekEndDate: dayjs().endOf('week').format('YYYY-MM-DD'),
            allDatesWithSlotInfo: [], // 新数组：存储所有日期及其是否有可用时间段的信息

            // 自定义时间选择器
            timePickerVisible: false,
            selectedTime: null,
            selectedStaff: null,

            // 自定义服务人员选择器
            staffPickerVisible: false,
            //非营业时间
            nonBusinessDays: [],
            year: initialDate.getFullYear(), // For API call fetchNonBusinessDays
            month: initialDate.getMonth() + 1, // For API call fetchNonBusinessDays (1-indexed)
            editType: true,
            resultViewMode: false,
            servicesID: null,
            departmentId: null,
            successDialogVisible_err: false,
            totalDuration: 0,
            serviceData: {},
            allServices: [],
            activeCategory: '',
            serviceListLoading: false,
            editOriginalServices: []
        }
    },
    created() {
        // 解析URL参数
        const servicesID = this.$route.query.id
        const departmentId = this.$route.query.departmentId
        this.departmentId = departmentId

        if (servicesID) {
            this.servicesID = servicesID

            // this.editType = false;
            this.fetchServiceById(servicesID)
            this.isViewMode = true
            this.isEditMode = false
            this.resultViewMode = true
        }
        const servicesParam = this.$route.query.services
        // 监听窗口大小变化
        window.addEventListener('resize', this.checkScreenSize)

        // 如果有服务参数，解析并显示
        if (servicesParam) {
            this.selectedServices = JSON.parse(decodeURIComponent(servicesParam))
            this.departmentId = this.selectedServices[0].departmentId
            this.calculateTotalPrice()
        }

        // 初始化日历
        this.initCalendar()
        // 获取非营业时间日期
        this.fetchNonBusinessDays()
    },
    destroyed() {
        // 移除事件监听器
        window.removeEventListener('resize', this.checkScreenSize)
    },
    computed: {
        filteredServices() {
            return this.allServices.filter(service => service.category === this.activeCategory)
        },
        currentWeekDisplay() {
            if (!this.calendarDays || !this.calendarDays.length || !this.calendarDays[0] || this.calendarDays[0].length !== 7) {
                // Fallback display, e.g., current month/year or loading text
                const date = this.currentDisplayDate || new Date()
                return formatDisplayDate(date)
            }
            const firstDay = this.calendarDays[0][0]
            const lastDay = this.calendarDays[0][6]

            const formatDate = day => {
                if (!day || day.date === null) return ''
                return formatDisplayDate(`${day.year}-${String(day.month + 1).padStart(2, '0')}-${String(day.date).padStart(2, '0')}`)
            }

            return `${formatDate(firstDay)} - ${formatDate(lastDay)}`
        }
    },
    methods: {
        formatDisplayDate,
        formatPrice,
        fetchServicesList() {
            if (!this.departmentId || this.serviceListLoading) return

            this.serviceListLoading = true
            axios
                .get(`${config.baseURL}api/serviceItem/open`, {
                    params: {
                        keyword: '',
                        departmentId: this.departmentId
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    if (response.data && response.data.code === 200) {
                        const selectedIds = new Set(this.selectedServices.map(service => Number(service.serviceId)))
                        const serviceData = {}
                        const allServices = []

                        Object.entries(response.data.data || {}).forEach(([categoryName, services]) => {
                            serviceData[categoryName] = {
                                count: services.length,
                                name: categoryName
                            }
                            services.forEach(service => {
                                allServices.push({
                                    name: service.name,
                                    price: service.price,
                                    description: service.description,
                                    duration: service.duration,
                                    category: categoryName,
                                    serviceId: service.id,
                                    selected: selectedIds.has(Number(service.id))
                                })
                            })
                        })

                        this.serviceData = serviceData
                        this.allServices = allServices
                        this.activeCategory = Object.keys(serviceData)[0] || ''
                    } else {
                        this.$message.error(response.data ? response.data.msg : 'Servizi non disponibili')
                    }
                })
                .catch(error => {
                    console.error('鑾峰彇鏈嶅姟鍒楄〃閿欒:', error)
                    this.$message.error('Servizi non disponibili')
                })
                .finally(() => {
                    this.serviceListLoading = false
                })
        },
        setActiveCategory(category) {
            this.activeCategory = category
        },
        getCategoryName(key) {
            return this.serviceData[key] ? this.serviceData[key].name : key
        },
        hasCategorySelected(category) {
            return this.allServices.some(service => service.category === category && service.selected)
        },
        toggleServiceSelection(service) {
            service.selected = !service.selected
            this.selectedServices = this.allServices
                .filter(item => item.selected)
                .map(item => ({
                    name: item.name,
                    price: item.price,
                    description: item.description,
                    category: item.category,
                    duration: item.duration,
                    serviceId: item.serviceId,
                    departmentId: this.departmentId
                }))
            this.calculateTotalPrice()
            this.availableTimes = []
            this.selectedTime = null
            this.fetchNonBusinessDays()
        },
        openLink() {
            this.successDialogVisible = false
            // 使用 Vue Router 的导航方法，适用于 hash 模式
            this.$router.push({
                path: '/home',
                query: { id: this.departmentId }
            })
        },
        cancelAppointment() {
            this.$confirm('Sei sicuro di voler annullare la tua prenotazione?', 'suggerimento', {
                confirmButtonText: 'Sicuro',
                cancelButtonText: 'Cancellare',
                type: 'warning'
            })
                .then(() => {
                    axios
                        .put(`${config.baseURL}api/appointment/open/cancel-group`, null, {
                            params: {
                                id: this.servicesID,
                                reason: '客户临时有事'
                            },
                            headers: {
                                languageCodes: 'it-IT'
                            }
                        })
                        .then(response => {
                            if (response.data && response.data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: 'Appuntamento annullato'
                                })
                                this.$router.push({
                                    path: `/cancel?id=${this.departmentId}`
                                })
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: response.data.msg
                                })
                            }
                        })
                        .catch(error => {
                            const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : 'Annullamento della prenotazione non riuscito'
                            this.$message({
                                type: 'error',
                                message
                            })
                        })
                })
                .catch(() => {
                    // 用户取消操作
                })
        },
        // 获取非营业时间日期
        fetchNonBusinessDays() {
            console.log(this.currentWeekStartDate)
            axios
                .get(`${config.baseURL}api/businessHours/open/available-slots`, {
                    params: {
                        departmentId: this.departmentId,
                        startTime: this.currentWeekStartDate,
                        endTime: this.currentWeekEndDate,
                        serviceDuration: this.totalDuration
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    if (response.data && response.data.code === 200) {
                        const availableSlotsByDate = response.data.data
                        const unavailableDates = []
                        if (availableSlotsByDate && typeof availableSlotsByDate === 'object') {
                            for (const dateKey in availableSlotsByDate) {
                                if (Object.prototype.hasOwnProperty.call(availableSlotsByDate, dateKey)) {
                                    const slots = availableSlotsByDate[dateKey]
                                    // Check if slots is an array and is empty
                                    if (Array.isArray(slots) && slots.length === 0) {
                                        unavailableDates.push(dateKey)
                                    }
                                }
                            }
                        }
                        this.nonBusinessDays = unavailableDates
                        console.log('Non-business days (dates with no available slots):', this.nonBusinessDays)

                        // 新增逻辑：收集有可用时间段的日期
                        const datesWithSlots = []
                        if (availableSlotsByDate && typeof availableSlotsByDate === 'object') {
                            for (const dateKey in availableSlotsByDate) {
                                if (Object.prototype.hasOwnProperty.call(availableSlotsByDate, dateKey)) {
                                    const slots = availableSlotsByDate[dateKey]
                                    // 检查 slots 是否为数组且长度大于0
                                    if (Array.isArray(slots) && slots.length > 0) {
                                        datesWithSlots.push(dateKey)
                                    }
                                }
                            }
                        }
                        // 更新 allDatesWithSlotInfo 数组
                        const processedDates = []
                        if (availableSlotsByDate && typeof availableSlotsByDate === 'object') {
                            for (const dateKey in availableSlotsByDate) {
                                if (Object.prototype.hasOwnProperty.call(availableSlotsByDate, dateKey)) {
                                    const slotsArray = availableSlotsByDate[dateKey]
                                    const hasSlots = Array.isArray(slotsArray) && slotsArray.length > 0
                                    processedDates.push({ date: dateKey, slots: slotsArray, hasSlots: hasSlots })
                                }
                            }
                        }
                        this.allDatesWithSlotInfo = processedDates
                        console.log('All dates with slot info:', this.allDatesWithSlotInfo)
                    } else {
                        console.error('获取非营业时间失败:', response.data ? response.data.msg : 'No response data')
                        this.nonBusinessDays = [] // Reset on error or bad response
                        this.allDatesWithSlotInfo = [] // 同时重置新数组
                    }
                })
                .catch(error => {
                    console.error('获取非营业时间错误:', error)
                })
        },
        // 检查屏幕尺寸
        checkScreenSize() {
            this.isMobile = window.innerWidth <= 768
        },
        // 计算总价
        calculateTotalPrice() {
            this.totalPrice = this.selectedServices
                .reduce((total, service) => {
                    // 使用parseFloat代替parseInt，保留小数部分
                    const priceValue = parseFloat(service.price) || 0
                    return total + priceValue
                }, 0)
                .toFixed(2) // 将结果格式化为两位小数
            this.totalDuration = this.selectedServices.reduce((total, service) => {
                const durationValue = parseFloat(service.duration) || 0
                return total + durationValue
            }, 0)
        },

        // 提交表单
        submitForm() {
            this.loading = true
            if (this.formData.date === 'Seleziona data') {
                this.$message.error('Seleziona data')
                this.loading = false
                return
            }
            if (this.formData.time === 'Scegli un orario') {
                this.$message.error('Scegli un orario')
                this.loading = false
                return
            }
            this.$refs.bookingForm.validate(valid => {
                if (valid) {
                    // 收集表单数据
                    const formData = {
                        serviceTime: dayjs(this.formData.date).format('YYYY-MM-DD') + ' ' + this.formData.time + ':00',
                        departmentId: this.departmentId,
                        type: '客户预约',
                        email: this.formData.email,
                        customerNote: this.formData.remark,
                        customer: {
                            name: this.formData.name,
                            phoneNo: this.formData.phone
                        },
                        appointmentServices: this.selectedServices.map(service => ({
                            serviceId: service.serviceId,
                            serviceName: service.name,
                            duration: service.duration,
                            price: service.price
                        }))
                    }
                    console.log(formData)
                    const staffOption = this.$el.querySelector(`.el-select-dropdown__item[class*="selected"] span`)
                    if (staffOption) {
                        formData.staffName = staffOption.textContent
                    }

                    axios
                        .post(`${config.baseURL}api/appointment/open`, formData, {
                            headers: {
                                'Content-Type': 'application/json;charset=UTF-8',
                                languageCodes: 'it-IT'
                            }
                        })
                        .then(response => {
                            if (response.data && response.data.code === 200) {
                                // 显示成功消息
                                this.successInfo = {
                                    title: 'Appuntamento confermato',
                                    message: 'Abbiamo inviato i dettagli dell’appuntamento al tuo numero di telefono e alla tua e-mail.\nTi aspettiamo!'
                                }
                                this.servicesID = response.data.data
                                this.successDialogVisible = true
                                setTimeout(() => {
                                    this.loading = false
                                }, 1000)
                            } else {
                                this.loading = false
                            }
                        })
                        .catch(error => {
                            console.error('预约提交失败:', error)
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        // 开始编辑
        startEdit() {
            this.isViewMode = false
            this.isEditMode = true
            this.editOriginalServices = JSON.parse(JSON.stringify(this.selectedServices))
            if (!this.allServices.length) {
                this.fetchServicesList()
            }
        },

        // 取消编辑
        cancelEdit() {
            this.selectedServices = JSON.parse(JSON.stringify(this.editOriginalServices))
            this.allServices.forEach(service => {
                service.selected = this.selectedServices.some(selectedService => Number(selectedService.serviceId) === Number(service.serviceId))
            })
            this.calculateTotalPrice()
            this.isViewMode = true
            this.isEditMode = false
        },

        // 保存编辑
        saveEdit() {
            this.loading = true
            if (this.selectedServices.length === 0) {
                this.$message.warning(this.$it.Select_at_least_one_service)
                this.loading = false
                return
            }
            this.$refs.bookingForm.validate(valid => {
                if (valid) {
                    // 收集表单数据
                    const formData = {
                        serviceTime: dayjs(this.formData.date).format('YYYY-MM-DD') + ' ' + this.formData.time + ':00',
                        departmentId: Number(this.departmentId),
                        type: '客户预约',
                        email: this.formData.email,
                        customerNote: this.formData.remark,
                        customer: {
                            name: this.formData.name,
                            phoneNo: this.formData.phone
                        },
                        appointmentServices: this.selectedServices.map(service => ({
                            serviceId: service.serviceId,
                            serviceName: service.name,
                            duration: service.duration,
                            price: service.price
                        }))
                    }

                    axios
                        .put(`${config.baseURL}api/appointment/open/${this.servicesID}`, formData, {
                            headers: {
                                'Content-Type': 'application/json;charset=UTF-8',
                                languageCodes: 'it-IT'
                            }
                        })
                        .then(response => {
                            if (response.data && response.data.code === 200) {
                                // 显示成功消息
                                this.successInfo = {
                                    title: 'Modifica riuscita',
                                    message: 'Modifica appuntamento avvenuta con successo'
                                }
                                this.successDialogVisible = true
                                setTimeout(() => {
                                    this.loading = false
                                }, 1000)
                                // 设置为查看模式
                                // this.isViewMode = true;
                                // this.isEditMode = false;
                            } else {
                                this.loading = false
                            }
                        })
                        .catch(error => {
                            console.error('更新预约失败:', error)
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        // 重置表单
        resetForm() {
            this.$refs.bookingForm.resetFields()
            this.formData = {
                date: 'Seleziona data',
                time: 'Scegli un orario',
                staffName: 'Arrivo in negozio',
                name: '',
                phone: '',
                email: '',
                remark: ''
            }
        },

        fetchServiceById(servicesID) {
            axios
                .get(`${config.baseURL}api/appointment/open?appointmentId=${servicesID}`, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    console.log('预约详情:', response.data)
                    if (response.data && response.data.code === 200) {
                        this.applyAppointmentDetail(response.data.data || {})
                    }
                })
                .catch(error => {
                    console.error('获取预约详情失败:', error)
                })
        },

        applyAppointmentDetail(data) {
            if (data.status === '已取消') {
                this.$message.error('Appuntamento annullato')
                this.$router.push({
                    path: `/cancel?id=${this.departmentId}`
                })
                return
            }

            const appointmentServices = data.appointmentServices || []
            const firstService = appointmentServices[0] || {}
            const serviceTime = firstService.serviceTime || data.serviceTime || ''
            const customer = data.customer || firstService.customer || {}
            const timeParts = this.splitServiceTime(serviceTime)

            this.formData.date = timeParts.date
            this.formData.time = timeParts.time
            this.formData.email = data.email || ''
            this.formData.remark = data.customerNote || data.remark || ''
            this.formData.name = customer.name || ''
            this.formData.phone = customer.phoneNo || ''
            this.selectedServices = this.mapAppointmentServices(appointmentServices)
            this.calculateTotalPrice()
        },

        mapAppointmentServices(appointmentServices) {
            return appointmentServices.map(service => ({
                id: service.id,
                appointmentId: service.appointmentId,
                serviceId: service.serviceId,
                name: service.serviceName,
                shortName: service.serviceShortName,
                duration: service.duration,
                price: service.price,
                serviceTime: service.serviceTime,
                staffId: service.staffId,
                color: service.serviceColor
            }))
        },

        splitServiceTime(serviceTime) {
            const parts = String(serviceTime || '').split(' ')
            return {
                date: parts[0] || 'Seleziona data',
                time: parts[1] || 'Scegli un orario'
            }
        },

        serviceColorStyle(color) {
            const normalizedColor = String(color || '').trim()
            return {
                backgroundColor: normalizedColor.startsWith('#') ? normalizedColor : `#${normalizedColor}`
            }
        },

        // 显示日期选择器
        showDatePicker() {
            if (this.isViewMode) return
            this.datePickerVisible = true
        },

        // 生成日历
        initCalendar() {
            const weekArray = []
            const startDate = this.getWeekStartDate(new Date(this.currentDisplayDate))

            for (let i = 0; i < 7; i++) {
                const currentDate = new Date(startDate)
                currentDate.setDate(startDate.getDate() + i)
                weekArray.push({
                    date: currentDate.getDate(),
                    month: currentDate.getMonth(), // 0-indexed
                    year: currentDate.getFullYear()
                })
            }
            this.calendarDays = [weekArray] // Structure as array of weeks for the template
        },

        // 切换月份
        getWeekStartDate(date) {
            const d = new Date(date)
            const dayOfWeek = d.getDay() // Sunday = 0, Monday = 1, ..., Saturday = 6
            d.setDate(d.getDate() - dayOfWeek) // Adjust to Sunday
            d.setHours(0, 0, 0, 0) // Normalize to start of the day
            return d
        },

        changeWeek(offset) {
            const newDate = new Date(this.currentDisplayDate)
            newDate.setDate(newDate.getDate() + offset * 7)
            this.currentDisplayDate = newDate

            // Update year and month for fetching non-business days and display if needed
            this.currentYear = this.currentDisplayDate.getFullYear()
            this.currentMonth = this.currentDisplayDate.getMonth() // 0-indexed

            this.year = this.currentYear // For API call
            this.month = this.currentMonth + 1 // For API call (1-indexed)

            // Calculate and log week start and end dates
            let weekStartDateObj = this.getWeekStartDate(new Date(this.currentDisplayDate))
            let weekEndDateObj = new Date(weekStartDateObj)
            weekEndDateObj.setDate(weekStartDateObj.getDate() + 6)

            // Format dates to YYYY-MM-DD
            const formatDate = dateObj => {
                const year = dateObj.getFullYear()
                const month = String(dateObj.getMonth() + 1).padStart(2, '0')
                const day = String(dateObj.getDate()).padStart(2, '0')
                return `${year}-${month}-${day}`
            }

            this.currentWeekStartDate = formatDate(weekStartDateObj)
            this.currentWeekEndDate = formatDate(weekEndDateObj)

            console.log('Current Week Start:', this.currentWeekStartDate)
            console.log('Current Week End:', this.currentWeekEndDate)

            this.fetchNonBusinessDays()
            this.initCalendar()
        },

        // 判断是否为今天
        isToday(day) {
            if (!day || day.date === null) return false
            const today = new Date()
            return day.date === today.getDate() && day.month === today.getMonth() && day.year === today.getFullYear()
        },

        // 判断是否为选中日期
        isSelected(day) {
            if (!day || day.date === null || !this.selectedDate) return false
            return this.selectedDate.date === day.date && this.selectedDate.month === day.month && this.selectedDate.year === day.year
        },

        // 判断是否为禁用日期
        isDisabledDate(day) {
            if (!day || day.date === null) return true // Disable empty/invalid day objects

            // Check if the date is before today
            const today = new Date()
            today.setHours(0, 0, 0, 0) // Normalize today to the start of the day

            const currentDate = new Date(day.year, day.month, day.date)
            currentDate.setHours(0, 0, 0, 0) // Normalize current processing day to the start of the day

            if (currentDate < today) {
                return true // Disable dates before today
            }

            // Original logic: Disable days based on slot availability
            const year = day.year
            const month = String(day.month + 1).padStart(2, '0') // day.month is 0-indexed
            const dateStr = String(day.date).padStart(2, '0')
            const formattedDate = `${year}-${month}-${dateStr}`

            const dateInfo = this.allDatesWithSlotInfo.find(info => info.date === formattedDate)

            if (dateInfo) {
                return !dateInfo.hasSlots // Disabled if it does NOT have slots
            }

            // If date is not found in allDatesWithSlotInfo (e.g., outside fetched range or API error),
            // or if it's a future date not yet processed for slots, consider it disabled as a safe default.
            return true
        },

        // 选择日期
        selectDate(day) {
            if (this.isDisabledDate(day)) return
            this.selectedDate = { ...day }
        },

        // 确认日期
        confirmDate() {
            if (!this.selectedDate) return

            // 格式化日期为 yyyy-MM-dd
            const year = this.selectedDate.year
            const month = String(this.selectedDate.month + 1).padStart(2, '0')
            const day = String(this.selectedDate.date).padStart(2, '0')
            const formattedSelectedDate = `${year}-${month}-${day}`
            this.formData.date = formattedSelectedDate
            this.datePickerVisible = false

            // 在 allDatesWithSlotInfo 中匹配选中的日期
            const matchedDateInfo = this.allDatesWithSlotInfo.find(info => info.date === formattedSelectedDate)
            if (matchedDateInfo) {
                this.availableTimes = matchedDateInfo.slots
                console.log('选中的日期:', formattedSelectedDate, '，详细信息:', matchedDateInfo, '是否有可用时间段:', matchedDateInfo.hasSlots)
            } else {
                console.log('选中的日期:', formattedSelectedDate, '，在已处理的API数据中未找到。')
            }
            this.$refs.bookingForm.validateField('date')
        },
        // 显示时间选择器
        showTimePicker() {
            if (this.isViewMode) return
            if (this.formData.date === 'Seleziona data') {
                this.$message.warning('Selezionare prima una data di prenotazione')
                // this.successInfo = {
                //     title: 'prompt',
                //     message: 'Selezionare prima una data di prenotazione'
                // }
                // this.successDialogVisible_err = true
                return
            }
            this.timePickerVisible = true
            // this.selectedTime = this.formData.time !== '请选择时间' ? this.formData.time : null;
        },

        // 选择时间
        selectTime(time) {
            this.selectedTime = time
        },

        // 确认时间选择
        confirmTime() {
            if (this.selectedTime) {
                this.formData.time = this.selectedTime
                this.$refs.bookingForm.validateField('time')
            }
            this.timePickerVisible = false
        }
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 15px 10px;
}

/* 顶部导航样式 */
.header {
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
    /* position: sticky;
    top: 0;
    z-index: 100; */
}

.header-content {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 10px;
}

.logo {
    height: 40px;
    margin-right: 15px;
}

.header-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.back-link {
    margin-top: 20px;
    display: inline-block;
    color: #666;
    text-decoration: none;
}

.back-link:hover {
    color: #333;
    text-decoration: underline;
}

/* 预约表单样式 */
.booking-section {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
    /* padding: 15px; */
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
}

.total-info {
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    margin-top: 15px;
}

.total-label {
    font-size: 16px;
    font-weight: bold;
}

.total-amount {
    font-size: 18px;
    font-weight: bold;
    color: #e74c3c;
}

/* 自定义 Element UI 样式 */
.el-card {
    margin-bottom: 15px;
    border-radius: 8px;
}

.el-form-item__label {
    font-weight: 500;
}

.service-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.service-info {
    flex: 1;
    padding-right: 10px;
}

.service-name {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    margin-bottom: 5px;
}

.service-color {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex: 0 0 10px;
}

.service-short-name {
    color: #999;
    font-size: 12px;
    font-weight: 400;
}

.service-duration {
    font-size: 13px;
    color: #666;
}

.service-time {
    font-size: 12px;
    color: #999;
    margin-top: 3px;
}

.service-price {
    font-weight: bold;
    font-size: 16px;
}

.service-edit-panel {
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    gap: 16px;
    margin-top: 18px;
    padding-top: 18px;
    border-top: 4px solid #f5f5f5;
}

.service-edit-panel .total-info {
    grid-column: 1 / -1;
}

.edit-service-categories {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eee;
}

.edit-category {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 10px;
    border: 0;
    border-left: 3px solid transparent;
    background: #f7f7f7;
    color: #333;
    cursor: pointer;
    text-align: left;
}

.edit-category.active {
    border-left-color: #ff6b81;
    background: #fff;
}

.edit-category.selected {
    color: #e74c3c;
    font-weight: 600;
}

.edit-service-list {
    min-height: 120px;
}

.service-option {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
}

.service-description {
    font-size: 13px;
    color: #999;
    margin-top: 4px;
}

.service-action {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    min-width: 110px;
}

.service-toggle {
    margin-top: 8px;
    padding: 4px 14px;
    border: 1px solid #ff6b81;
    border-radius: 6px;
    background: #fff;
    color: #ff6b81;
    cursor: pointer;
    font-size: 14px;
}

.service-toggle.selected {
    border-color: #67c23a;
    background: #f0f9eb;
    color: #67c23a;
}

.service-empty {
    padding: 18px 0;
    color: #999;
    text-align: center;
}

.info-group-title {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 12px;
    color: #333;
}

/* 移动端适配样式 */
@media (max-width: 768px) {
    .container {
        padding: 10px 8px;
    }

    .header-title {
        font-size: 18px;
    }

    .section-title {
        font-size: 16px;
        margin-bottom: 12px;
        padding-bottom: 6px;
    }

    .el-form-item {
        margin-bottom: 18px;
    }

    .el-form-item__label {
        padding: 0 0 8px;
        line-height: 1.4;
        text-align: left;
    }

    .el-form--label-top .el-form-item__label {
        padding: 0 0 8px;
    }

    .el-dialog {
        width: 90% !important;
        margin-top: 20vh !important;
    }

    .service-name {
        font-size: 15px;
    }

    .service-price {
        font-size: 15px;
    }

    .service-edit-panel {
        grid-template-columns: 1fr;
    }

    .edit-service-categories {
        flex-direction: row;
        gap: 10px;
        overflow-x: auto;
        border-right: 0;
        padding-bottom: 10px;
        scrollbar-width: none;
    }

    .edit-service-categories::-webkit-scrollbar {
        display: none;
    }

    .edit-category {
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 8px 15px;
        border-left: 0;
        border-bottom: 0;
        border-radius: 20px;
        background: #f5f5f5;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 400;
    }

    .edit-category.active {
        background: #ff6b81;
        color: #fff;
    }

    .edit-category.selected:not(.active) {
        color: #333;
        font-weight: 400;
    }

    .edit-service-list {
        padding-top: 4px;
    }

    .service-option {
        padding: 16px 0;
        align-items: flex-start;
    }

    .service-action {
        min-width: 100px;
    }

    .service-toggle {
        padding: 5px 14px;
        border-radius: 6px;
    }

    .total-label {
        font-size: 15px;
    }

    .total-amount {
        font-size: 16px;
    }
}

/* 自定义日期选择器样式 */
.custom-date-picker {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 14px !important;
    padding: 6px 0;
    border-bottom: 1px solid #eee;
}

.date-picker-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.date-picker-content {
    background-color: #fff;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.date-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
}

.date-picker-header h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
}

.close-btn {
    font-size: 24px;
    cursor: pointer;
    color: #999;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
}

.nav-btn {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    padding: 5px 10px;
}

.current-month {
    font-size: 16px;
    font-weight: bold;
}

.calendar {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.calendar th,
.calendar td {
    text-align: center;
    padding: 8px 0;
}

.calendar th {
    font-weight: normal;
    color: #666;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
}

.calendar-day {
    display: inline-block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    cursor: pointer;
}

.calendar-day.empty-day {
    background-color: transparent;
    cursor: default;
}

/* .calendar-day.other-month {
    color: #c0c4cc;
} */

.calendar-day.today {
    color: #e74c3c;
    font-weight: bold;
}

.calendar-day.selected {
    background-color: #e74c3c !important;
    color: white;
}

.calendar-day:hover:not(.other-month):not(.empty-day):not(.disabled) {
    background-color: #f2f6fc;
}

.calendar-day.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
}

.date-picker-footer {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    border-top: 1px solid #eee;
}

.cancel-btn,
.confirm-btn {
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.cancel-btn {
    background-color: #f5f5f5;
    color: #666;
}

.cancel-btn:hover {
    background-color: #e9e9e9;
}

.confirm-btn {
    background-color: #e74c3c;
    color: #fff;
}

.confirm-btn:hover {
    background-color: #e45858;
}

/* 时间选择器样式 */
.time-list {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
}

.time-item {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    background: #fff;
}

.time-item:hover {
    background-color: #f9f9f9;
}

.time-item.selected {
    background-color: #ffcdd2;
    color: #fff;
}

@media (max-width: 768px) {
    .cancels {
        margin-top: 10px;
    }
    .el-button + .el-button {
        margin-left: 0;
    }
    .cancels2 {
        margin-left: 10px !important;
    }
}

.successInfo-message {
    word-break: keep-all;
    white-space: pre-line;
}
</style>
